// Update log
// FB  6192   02/06/2023  DK  Added page to handle Classes and objects
// FB  6915   06/06/2023  DK  Test results acknowledgement
// FB  6905   05/31/2023  SK  PP Changes on Billing invoice screen
// FB  7074   07/26/2023  SK  Patient Portal : Develop the feature of message reply
// FB  7129   09/05/2023  SK  Improve GUI For Updating Documents on PE and Portal
// FB  7323   09/11/2023  GA  When Payment Comes from the Patient Portal, the Transactions Payment Type Must be Credit Card Patient Portal
// FB  7413   09/25/2023  GA  Orady - Update the map link to the correct one
// FB  7541   10/16/2023  SK  Implementing a feature that allows patients to upload clinical documents via a patient portal
// FB  7787   11/30/2023  DK  Incorrect date is being posted on portal
// FB  8024   01/03/2024  SK  Including Recent Patient Engagement Enhancements to Patient Portal
// FB  8099   01/17/2024  SK  IAdd Support to Patient Portal to Facilitate Patients Seeing their Invoices and Optionally being able to Pay
// FB  8881   06/14/2024  SK  Show Billing Details in Portal for All Patients in Guest Login Interface
// FB  8549   10/21/2024  DK  TeleHealth re-work
// FB  9464   10/08/2024  KI    created new screen for displaying lab orders
// FB  9639   12/02/2024  DK  Employee Groups that are Set to be Portal Addressees.
// FB  10390  04/15/2025  DK  Cures Act compliance


import { createContext } from "react";
import { Actions } from "../actions";

export type Patient = {
  Patient_N: string;
  PatientFirstName: string;
  PatientLastName: string;
  PatientPrimaryAddress: string;
  PatientSecondAddress: string;
  PatientCity: string;
  PatientZIP: string;
  PatientEmail: string;
  PatientCellPhone: string;
  PatientDOB: Date;
  PatientGender: string;
  PatientGender2: string;
  StateID: number;
  PatientPassword: string;
  PatientPassword2: string;
  Login: string;
  BloodTypeID: number;
  EmploymentStatusID: number;
  MaritalStatusID: number;
  StaffID: number;
  WebSiteID: number;
  EMRID: number;
  InsuranceName: string;
};

export type Login = {
  Username: string;
  Password: string;
  IsGuardian: boolean;
};

export type PswdReset = {
  Password: string;
  NewPassword: string;
  ConfirmPassword: string;
};

export type Appointment = {
  Date: Date;
  Location: string;
  Provider: string;
  Type: string;
};

export type TestResult = {
  TestType: string;
  TestDate: Date;
  Physician: string;
  DocumentID: number;
  Annotation: string;
  EMRID: number;
  //FB 6915
  IsReviewed: number;
  PatientID: number;
  AcknowledgedOn: Date;
};
export type DeleteGuardian = {
  patientid: any;
  WebsiteID: number;
  Auth_Login: string;
};
export type EMRConfig = {
  EMRURL: string;
  WebsiteID: number;
};

export type Message = {
  ID: number;
  Subject: string;
  Body: string;
  DateSent: Date;
  DateCreated: Date;
  IsRead: number;
  Priority: number;
  Direction: number;
  PhysicianID: number;
  Is_Group_Message: boolean;   //FB 9639
};

export type ActivityLogs = {
  DateRecorded: Date;
  IP: string;
  Action: string;
  User: string;
  TransmitTo: string;
  TransmitStatus: string;
};

export type Physician = {
  ID: number;
  Name: string;
};
export type OnCardDetial = {
  value: string;
  error: string;
  errorMsg: string | null | undefined;
};

export type CreditCardPaymentModelTrial = {
  firstNameOnCard: OnCardDetial;
  lastNameOnCard: OnCardDetial;
  address: OnCardDetial;
  address2: OnCardDetial;
  city: OnCardDetial;
  zip: OnCardDetial;
  email: OnCardDetial;
  cellphone: OnCardDetial;
  cvc: OnCardDetial;
  month: OnCardDetial;
  year: OnCardDetial;
  paymentAmount: OnCardDetial;
};
export type CreditCardPaymentModel = {
  firstNameOnCard: string;
  lastNameOnCard: string;
  PaymentToken: string;
  ValidateOrAcceptPayment: string;
  ExpirationDate: any;
  CNP: string;
  PaymentAmount: any;
  address: string;
  address2: string;
  city: string;
  state: string;
  month: string;
  year: string;
  zip: string;
  phone: string;//FB 8099
  email: string;
  Memo: string;
  Memo2: string;
  FeeAmount: string;
  Patient_N: number;
  SAVE_CARD: number;
  CARD_NAME: string;
  EMPLOYEE_N: number;
  COMMENT: string;
  IS_PORTAL_PAYMENT: number;// FB 7323
};

export type Medication = {
  ID: number;
  Name: string;
  Dosage: string;
  Strength: string;
  ModifyDate: Date;
  CreateDate: Date;
  Pharmacy: string;
};

//FB 8881 - Begin
export type InvoiceModal = {
  INVOICE_PRINT_LOG_N: number;
  PRINT_DATE: Date;
  PATIENT_N: number;
  EMPLOYEE_N: number;
  INVOICE_NUMBER: number;
  AMOUNT: number;
};
//FB 8881 - End

export type CCDA = {
  ID: number;
  Date: Date;
  XML: string;
};

export type State = {
  StateID: number;
  StateShortName: string;
  StateFullName: string;
};

export type Guardian = {
  PatientAccessCode: string;
  patientid: number;
  PatientLogin: string;
  WebsiteID: number;
  Auth_Login: string;
  Auth_FirstName: string;
  Auth_LastName: string;
  password: string;
  relation: string;
  Auth_DOB: Date;
  active_flag: boolean;
};

export type FindPharmacy = {
  Name: string;
  Address1: string;
  City: string;
  State: string;
  Zip: string;
  Phone: string;
  Fax: string;
  RcopiaID: string;
  NCPDPID: string;
};
export type Insurance = {
  PATIENT_INSURANCE_CARRIER: string;
  PATIENT_INSURANCE_CARRIER_ID: string;
  PATIENT_SECONDARY_INSURANCE_CARRIER_ID: string;
  PATIENT_SECONDARY_INSURANCE_CARRIER: string;
  PATIENT_THIRD_INSURANCE_CARRIER_ID: string;
  PATIENT_THIRD_INSURANCE_CARRIER: string;
  PATIENT_INSURANCE_CARRIER_GROUP: string;
  PATIENT_SECONDARY_INSURANCE_CARRIER_GROUP: string;
  PATIENT_THIRD_INSURANCE_CARRIER_GROUP: string;
};

export type SelectedPharmacy = {
  PHARMACY_RCOPIAID: any;
  PHARMACY_DESCRIPTION: any;
  PHARMACY_NAME: any;
  PHARMACY_NCPDPID: any;
};

export type AppointmentObject = {
  AppointmentType: string;
  CustomAppointmentType: string; //FB 8024
  AppointmentFilter: string;
  Provider: Provider;
  Facility: Facility;
  FacilityRegion: FacilityRegion;
  AppointmentDate: Date;
  Duration: number;
  SlotDetails: SlotDetails;
  Appointment_N: number;
};

export type Provider = {
  ID: number;
  Name: string;
  Facility_n: number;
  Bio: string;
  JobTitle: string;
};

export type FacilityRegion = {
  ID: number;
  Name: string;
  State: string;
};

export type Facility = {
  ID: number;
  Name: string;
  Address: string;
  Phone: string;
  Region: number;
  GOOGLE_MAPS_LINK: string; //FB 7413
};


export type SupportFile = {
  DocumentType: string;
  OtherDocument: string;
  FileName: string;
  FileType: string;
  FileSize: number;
  Base64EncodedFile: string;
  Appointment_N: number;
  previewUrl: any;//FB 7129
};

//FB 7541 - Begin
export type SupportFileUpload = {
  DocumentType: string;
  OtherDocument: string;
  FileName: string;
  FileType: string;
  FileSize: number;
  Base64EncodedFile: string;
  Patient_N: number;
  previewUrl: any;
};
//FB 7541 - End

export type InputFile = {
  SessionId: number;
  ImageId: number;
  TempId: string;
  Image: string;
};

export type Slots = {
  ScheduleDate: string;
  Slots: string[];
  ApptTypeSlots: string[];//FB 8024
};

export type ProviderSchedule = {
  Facility_N: number;
  Facility_Name: string;
  Facility_Address: string;
  Facility_Info: string;
  NextAvailability: string;
  SlotsDate: Slots[];
  Scheduling_Phone: string;
  AvailableSlotsCount: number;
  Duration: number;
  GOOGLE_MAPS_LINK: string; //FB 7413
};

export type FacilitySchedule = {
  Employee_N: number;
  Employee_First_Name: string;
  Employee_Last_Name: string;
  Facility_Info: string;
  NextAvailability: string;
  SlotsDate: Slots[];
  SchedulinPhone: string;
  Employee_Bio: string;
  AvailableSlotsCount: number;
  Duration: number;
  Employee_Job_Title: string;
};

export type SchedulesByDate = {
  Employee_N: number;
  Employee_First_Name: string;
  Employee_Last_Name: string;
  Employee_Image: string;
  NextAvailability: string;
  FacilityByDate: FacilityByDate[];
  Employee_Bio: string;
  AvailableSlotsCount: number;
  Duration: number;
  Employee_Job_Title: string;
};

export type FacilityByDate = {
  Facility_n: number;
  Facility_Name: string;
  Facility_Address: string;
  Facility_City: string;
  Facility_State: string;
  Facility_Zip: string;
  Slots: string[];
  SchedulinPhone: string;
  GOOGLE_MAPS_LINK: string; //FB 7413
  ApptTypeSlots: string[]; //FB 8024
};

export type SlotDetails = {
  id: number;
  slotDate: Date;
  employeeId: number;
  facilityId: number;
  employeeName: string;
  facilityName: string;
  isslotexisting: boolean;
  duration: number;
};

export type HeaderLogo = {
  FileName: string;
  FileType: string;
  FileSize: number;
  Base64EncodedFile: string;
  WebsiteID: number;
};

export type ClinicalDocument = {
  CATEGORY_N: number;
  CATEGORY_LABEL: string;
  SESSION_N: number;
  SESSION_DATE: string;	//FB 7787
  IS_NOTE_COMPLETE_FLAG: number; //FB 10390
};

//FB 9464
export type LabOrder = {
  LAB_ORDER_N: number;
  LAB_ORDER_MODIFY_DATE: string;
  LABORATORY_NAME: string;
  EMPLOYEE_FIRST_NAME: string;
};


//FB 6905 - Start
export type DetialsProps = {
  Patient_ID: number;
  PATIENT_NAME: string;
  PATIENT_ADDRESS: string;
  PATIENT_CITY_STATE_ZIP: string;
};
//FB 6905 - End

//FB 8549
export type AppointmentType = {
  Id: number;
  NAME: string;
  COLOR: string;
  DURATION: number;
  ACTIVE_FLAG: number;
  NO_DOUBLE_BOOKING: number;
  NO_DOUBLE_BOOKING_FOR_DOCTOR: number;
  TIME_SLOT: number;
  NO_FURTHER_BOOKING: number;
  MAX_PER_HOUR: number;
  LEFT_MOST_COLUMN: number;
  MAX_PER_HALF_HOUR: number;
  IS_TELE_APPOINTMENT: number;
  IS_PE_ENABLED: number;
  ENABLE_FOR_NEW_PATIENT: number;
  ENABLE_FOR_EXISTING_PATIENT: number;
}

export const InitialSlotsObj: SlotDetails = {
  employeeId: 0,
  facilityId: 0,
  id: 0,
  slotDate: new Date(),
  employeeName: "",
  facilityName: "",
  isslotexisting: false,
  duration: 0,
};

export const InitialApptObj: AppointmentObject = {
  AppointmentType: "",
  CustomAppointmentType: "", //FB 8024
  AppointmentFilter: "",
  Provider: {
    ID: 0,
    Name: "",
    Facility_n: 0,
    Bio: "",
    JobTitle: "",
  },
  Facility: {
    ID: 0,
    Name: "",
    Address: "",
    Phone: "",
    Region: 0,
    GOOGLE_MAPS_LINK: "" //FB 7413
  },
  FacilityRegion: {
    ID: 0,
    Name: "",
    State: "",
  },
  AppointmentDate: new Date(),
  Duration: 0,
  SlotDetails: InitialSlotsObj,
  Appointment_N: 0,
};

export const ApptContext = createContext<{
  state: AppointmentObject;
  dispatch: React.Dispatch<Actions>;
}>(undefined as any);

//FB 9639 Replaced Replymail
export type Recipient = {
  ID: number;
  Name: string;
  Is_Group: boolean;
}
